<template>
  <div class="col-md-12">
    <div class="text-center" v-if="loadingTabela">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <b-table v-else responsive="sm" :items="itemsTabela" :fields="fields" per-page="10" :current-page="currentPage"
      bordered striped>
    </b-table>
    <div class="row align-items-center">
      <div class="col-12 text-center" v-if="!loadingTabela && !itemsTabela.length">
        <span class="fs-6 text-secondary">Nenhum projeto cadastrado para este cliente rural.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sqCliente: null,
      fields: [
        {
          key: "CDPRODUTO",
          label: "Código",
        },
        {
          key: "NM_PROJETO",
          label: "Projeto",
        },
      ],
      loadingTabela: true,
      itemsTabela: [],
      currentPage: 1,
      itemsPerPage: 10
    };
  },
  created(){
    if(this.$store.state.clienteRuralAstec){
      this.sqCliente = this.$store.state.clienteRuralAstec.ID ?? null;
      this.buscarTabelaEmailAstec();
    }
  },
  methods: {
    async buscarTabelaEmailAstec() {
      try {
        this.loadingTabela = true;
        const response = await this.$http.get("api/astec/getClienteRuralProjetos/" + this.sqCliente);
        this.itemsTabela = response.data;
        this.$emit("visibilidade-botao", true);
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loadingTabela = false;
      }
    },


  },
};
</script>

